import { useTranslation } from "react-i18next";
import styles from "./Search.module.scss";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useState } from "react";
import InputSearch from "../../../components/InputSearch";

interface Props {
  handleSearch: (search: string, criteria: Number) => void;
  changeCriteria?: (search: string, criteria: Number) => void;
  searchDefault?: string;
  criteriaDefault?: Number;
}

const SearchForm: React.FC<Props> = ({
  handleSearch,
  changeCriteria,
  searchDefault,
  criteriaDefault,
}) => {
  const { t } = useTranslation();

  enum SearchCriterias {
    Title,
    TicketNumber,
    EzShareId,
    Author,
  }

  const [searchCriteria, setSearchCriteria] = useState<Number>(
    criteriaDefault ?? SearchCriterias.Title
  );

  const [search, setSearch] = useState<string>(searchDefault ?? "");

  return (
    <div className={styles.searchForm}>
      <div className={styles.searchField}>
        <InputSearch
          placeholder="searchPublications"
          valueDefault={search}
          onChange={(e) => {
            setSearch(e);
          }}
          onSearch={(e) => {
            setSearch(e);
            handleSearch(e, searchCriteria);
          }}
        />
      </div>
      <div className={styles.searchCriteria}>
        <div className={styles.label}>
          <p>{t("searchCriteria")}</p>
        </div>
        <Select<Number>
          id="criteria"
          className={styles.criteria}
          value={searchCriteria}
          onChange={(e) => {
            let criteria = e.target.value as Number;
            setSearchCriteria(criteria);
            if (changeCriteria) changeCriteria(search, criteria);
          }}
        >
          <MenuItem key={`sc_title`} value={SearchCriterias.Title}>
            {t("searchCriterias.title")}
          </MenuItem>
          <MenuItem
            key={`sc_ticketNumber`}
            value={SearchCriterias.TicketNumber}
          >
            {t("searchCriterias.ticketNumber")}
          </MenuItem>
          <MenuItem key={`sc_ezShareId`} value={SearchCriterias.EzShareId}>
            {t("searchCriterias.ezShareId")}
          </MenuItem>
          <MenuItem key={`sc_author`} value={SearchCriterias.Author}>
            {t("searchCriterias.author")}
          </MenuItem>
        </Select>
      </div>
    </div>
  );
};

export default SearchForm;
